export default __webpack_public_path__ + "media/images/logos/wordmark_dark-ef711b74847f848527654e5af7d00aa1.png";